import { Chip } from '@mui/material'
import { CampaignType } from 'graphql/generated/graphql'
import React from 'react'

interface CampaignTypeBadgeProps {
  type: CampaignType | string
}

export function CampaignTypeBadge({ type }: CampaignTypeBadgeProps) {
  const config: Record<string, { label: string; backgroundColor: string; color: string }> = {
    [CampaignType.Query]: { 
      label: 'Niche', 
      backgroundColor: '#10b981',
      color: '#ffffff'
    },
    [CampaignType.Brand]: { 
      label: 'Brand', 
      backgroundColor: '#6366f1',
      color: '#ffffff'
    },
    [CampaignType.Competitor]: { 
      label: 'Competitor', 
      backgroundColor: '#ff9800',
      color: '#ffffff'
    }
  }

  const { label, backgroundColor, color } = config[type] || config[CampaignType.Query]

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor,
        color,
        fontWeight: 600,
        fontSize: '0.75rem',
        height: '24px',
        borderRadius: '6px'
      }}
    />
  )
}